import { render, staticRenderFns } from "./ModalAmbiente.vue?vue&type=template&id=34ba0290&lang=pug"
import script from "./ModalAmbiente.vue?vue&type=script&lang=js"
export * from "./ModalAmbiente.vue?vue&type=script&lang=js"
import style0 from "./ModalAmbiente.vue?vue&type=style&index=0&id=34ba0290&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports